import { useEffect, useState } from 'react';

const useAppRedirect = () => {
    const [showModal, setShowModal] = useState(false);

    useEffect(() => {
        const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
        const alreadyPrompted = sessionStorage.getItem('appPromptShown');

        if (isMobile && !alreadyPrompted) {
            setShowModal(true);
        }
    }, []);

    const openApp = () => {
        const isAndroid = /Android/i.test(navigator.userAgent);
        const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);

        // Try opening the app via deep link
        window.location.href = 'partywitty://home';

        // If app isn't installed, redirect to appropriate store
        setTimeout(() => {
            if (isAndroid) {
                window.location.href = 'https://play.google.com/store/apps/details?id=com.party.partywitty_guest';
            } else if (isIOS) {
                window.location.href = 'https://apps.apple.com/in/app/partywitty/id6478442502';
            }
        }, 1500); // Adjust timeout as needed

        // Set flag to not show modal again
        sessionStorage.setItem('appPromptShown', 'true');
        setShowModal(false);
    };


    const continueInBrowser = () => {
        sessionStorage.setItem('appPromptShown', 'true');
        setShowModal(false);
    };

    return { showModal, openApp, continueInBrowser };
};

export default useAppRedirect;
